module.exports = __webpack_public_path__ + "img/113.9.127b7f1b.png";